import http from '../../http-common'

type Access = { ref: string; state: string; playback_url?: string; expires_at?: string; download_url?: string }
type Pending = { ref: string; resolve: (access: Access) => void; reject: (error: unknown) => void }
const waiting = new Map<string, Pending[]>()
const cache = new Map<string, Access>()
let generation = 0

/** Coalesce requests made by visible attachments in the same turn into batches <=100. */
export function requestMediaAccess(
  scope: string,
  roomId: string | number,
  ref: string,
  refresh = false,
): Promise<Access> {
  const room = `${scope}:${roomId}`
  const key = `${room}:${ref}`
  const cached = cache.get(key)
  if (!refresh && cached?.playback_url && Date.parse(cached.expires_at || '') > Date.now() + 5000)
    return Promise.resolve(cached)
  const currentGeneration = generation
  return new Promise((resolve, reject) => {
    let batch = waiting.get(room)
    if (!batch) {
      batch = []
      waiting.set(room, batch)
      queueMicrotask(async () => {
        waiting.delete(room)
        const refs = [...new Set(batch!.map((item) => item.ref))]
        for (let offset = 0; offset < refs.length; offset += 100) {
          const references = refs.slice(offset, offset + 100)
          const items = batch!.filter((item) => references.includes(item.ref))
          try {
            const { data } = await http.post(
              `/communication/${roomId}/media-access/`,
              { references },
              { timeout: 30_000 },
            )
            for (const item of items) {
              const access = data.results.find((entry: Access) => entry.ref === item.ref)
              if (!access) {
                item.reject(new Error('Anexo ausente na resposta'))
                continue
              }
              if (currentGeneration === generation) cache.set(`${room}:${item.ref}`, access)
              item.resolve(access)
            }
          } catch (error) {
            items.forEach((item) => item.reject(error))
          }
        }
      })
    }
    batch.push({ ref, resolve, reject })
  })
}

export function clearMediaAccess(scope: string, roomId: string | number) {
  const prefix = `${scope}:${roomId}:`
  for (const key of cache.keys()) if (key.startsWith(prefix)) cache.delete(key)
}

export function clearAllMediaAccess() {
  generation++
  cache.clear()
}
